import React from 'react'

import { LOGIN_URL_WITH_REDIRECT } from 'configs/auth'
import { Loading } from 'react-admin'

const LoginPage = () => {
  window.location.href = LOGIN_URL_WITH_REDIRECT

  return (
    <>
      <Loading />
    </>
  )
}

export default LoginPage
